/*
  POUFF corner newsletter popup (design spec: 4c desktop / 4d mobile).

  This is the trigger/teaser/success-step logic for the corner popup
  specifically. Suppression (closed/subscribed), the cross-popup mutex, and
  Klaviyo event tracking are shared with the full-screen popup (4a/4b) via
  assets/pouff-newsletter-shared.js — see that file for why, and for the
  reasoning behind the Klaviyo event-tracking approach it uses.

  The actual Klaviyo subscribe call is NOT here. The form is marked
  [data-pouff-klaviyo-form] and assets/pouff-klaviyo.js (already loaded
  sitewide via sections/footer.liquid) intercepts its submit and posts to
  Klaviyo's client API, writing success/error text into the form's
  [data-pouff-klaviyo-status] element. This file watches that element for
  changes (via MutationObserver) rather than duplicating the network call,
  so there is exactly one Klaviyo integration in the theme, not two.
*/
(function () {
  var ROOT_SELECTOR = '[data-pouff-corner-popup]';
  var EMAIL_RE = /^\S+@\S+\.\S+$/;
  var SUCCESS_AUTO_CLOSE_MS = 5000;

  function init(root) {
    var shared = window.PouffNewsletterPopups;
    if (!shared) return;

    var delaySeconds = parseInt(root.getAttribute('data-delay-seconds'), 10) || 5;
    var suppressDays = parseInt(root.getAttribute('data-suppress-days'), 10) || 30;
    var phoneDelaySeconds = parseInt(root.getAttribute('data-phone-delay-seconds'), 10) || 40;
    var phoneScrollPercent = parseInt(root.getAttribute('data-phone-scroll-percent'), 10) || 50;
    var isPhone = window.matchMedia('(max-width: 749px)').matches;

    var card = root.querySelector('.pouff-corner-popup__card');
    var teaser = root.querySelector('[data-pouff-corner-popup-teaser]');
    var formStep = root.querySelector('[data-pouff-corner-popup-step="form"]');
    var successStep = root.querySelector('[data-pouff-corner-popup-step="success"]');
    var form = root.querySelector('[data-pouff-corner-popup-form]');
    var emailInput = root.querySelector('[data-pouff-corner-popup-email]');
    var formatError = root.querySelector('[data-pouff-corner-popup-format-error]');
    var statusEl = root.querySelector('[data-pouff-klaviyo-status]');
    var closeButtons = root.querySelectorAll('[data-pouff-corner-popup-close]');

    if (!card || !form || !emailInput) return;

    var companyId = form.getAttribute('data-pouff-klaviyo-company');

    function showCard() {
      if (!shared.claim()) return;
      root.hidden = false;
      card.hidden = false;
      teaser.hidden = true;
      shared.trackEvent(companyId, 'Viewed corner popup');
      // Next frame, so the transition in the stylesheet actually animates in.
      window.requestAnimationFrame(function () {
        root.setAttribute('data-pouff-corner-popup-open', '');
      });
    }

    // Hides the card only — never the shared root, since the teaser lives
    // inside that same root and must stay visible after the card closes.
    function hideCard() {
      root.removeAttribute('data-pouff-corner-popup-open');
      shared.release();
      window.setTimeout(function () {
        card.hidden = true;
      }, 250);
    }

    function showTeaser() {
      hideCard();
      root.hidden = false;
      teaser.hidden = false;
    }

    function closeToTeaser() {
      shared.markClosed();
      showTeaser();
    }

    function reopenFromTeaser() {
      formStep.hidden = false;
      successStep.hidden = true;
      showCard();
    }

    function showSuccessStep() {
      formStep.hidden = true;
      successStep.hidden = false;
      shared.trackEvent(companyId, 'Subscribed via corner popup');
      shared.markSubscribed();
      window.setTimeout(function () {
        hideCard();
        teaser.hidden = true;
      }, SUCCESS_AUTO_CLOSE_MS);
    }

    closeButtons.forEach(function (btn) {
      btn.addEventListener('click', closeToTeaser);
    });

    teaser.addEventListener('click', reopenFromTeaser);

    emailInput.addEventListener('input', function () {
      formatError.hidden = true;
    });

    form.addEventListener('submit', function (event) {
      if (!EMAIL_RE.test(emailInput.value.trim())) {
        event.preventDefault();
        event.stopImmediatePropagation();
        formatError.hidden = false;
      }
    });

    if (statusEl) {
      var observer = new MutationObserver(function () {
        var text = statusEl.textContent || '';
        var isError = statusEl.hasAttribute('data-pouff-klaviyo-error');
        if (text && !isError) {
          showSuccessStep();
        }
      });
      observer.observe(statusEl, { childList: true, characterData: true, subtree: true });
    }

    if (/[?&]popup=fullscreen(&|$)/.test(window.location.search)) return;
    if (/[?&]popup=corner(&|$)/.test(window.location.search)) {
      window.setTimeout(showCard, 300);
      return;
    }

    // When the red full-screen popup is on the page, this one only appears
    // after the visitor has seen it its full number of times without
    // subscribing.
    var fullscreenRoot = document.querySelector('[data-pouff-fullscreen-popup]');
    if (fullscreenRoot) {
      var maxShows = parseInt(fullscreenRoot.getAttribute('data-max-shows'), 10) || 3;
      if (shared.getFullscreenShows() < maxShows) return;
    }

    if (shared.onCartPage() || shared.isSubscribed() || shared.isSuppressedByRecentClose(suppressDays)) {
      return;
    }

    if (isPhone) {
      // Phones: never on product pages (they carry their own email block and the sticky
      // buy bar), and never on first load. Wait for real engagement: scrolled about half
      // the page, or a long dwell, whichever comes first.
      if (/^\/products\//.test(window.location.pathname)) return;

      var fired = false;
      var dwellTimer;
      var onScroll = function () {
        var scrollable = document.documentElement.scrollHeight - window.innerHeight;
        if (scrollable > 0 && (window.pageYOffset / scrollable) * 100 >= phoneScrollPercent) go();
      };
      var go = function () {
        if (fired) return;
        fired = true;
        window.clearTimeout(dwellTimer);
        window.removeEventListener('scroll', onScroll);
        showCard();
      };
      dwellTimer = window.setTimeout(go, phoneDelaySeconds * 1000);
      window.addEventListener('scroll', onScroll, { passive: true });
      return;
    }

    window.setTimeout(showCard, delaySeconds * 1000);
  }

  document.querySelectorAll(ROOT_SELECTOR).forEach(init);
})();
